import state from './moduleTaxDataManagementState';
import mutations from "./moduleTaxDataManagementMutations";
import actions from "./moduleTaxDataManagementActions";

export default {
  namespaced: true,
  state: state,
  mutations,
  actions,
}
